import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { RootState } from "../../shared/store";
import { PolicyDtoRead } from "../model/PolicyDtoRead";
import CustomerEditPolicyDetails from "./customer-edit-policy/CustomerEditPolicyDetails";
import './CustomerPolicyList.scss';
import CustomerPolicySummary from "./CustomerPolicySummary";
import { PolicyTransactionsReadDto } from "../model/PolicyTransactionsReadDto";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "../../components/components/Modal";
import CustomerNewPolicy from "./customer-policy-action/Customer-Policy-Action";
import * as constant from '../../shared/util/constant';
import { PolicyDto } from "../model/PolicyDto";
import { CommonUtility } from "../../Services/CommonUtility";
import * as labelconstant from '../../shared/util/label';
import { Column, Label, Row, Select } from '../../components';
import { SelectOption } from "../../shared/components/input/SelectOption";

export interface ICustomerPolicyListComponent
{
    customerId : string;
    policyId?: string;
    polEventId?: string;
};

interface LocationState {
    policyTransactionClicked?: PolicyTransactionsReadDto;
    policyId?: string;
}

const CustomerPolicyList: React.FunctionComponent<ICustomerPolicyListComponent> = (props) => {
    const location = useLocation();
    const path = location.pathname.indexOf("policy-details");
    const receivedState = location.state as LocationState | undefined;
    const policyTransactionSelected = receivedState?.policyTransactionClicked;

    const [selectedPolicyType, setSelectedPolicyType] = useState('');
    const [selectedPolicyStatus, setSelectedPolicyStatus] = useState('');
    const [policyTypeOptions, setPolicyTypeOptions] = useState<SelectOption[]>([]);
    const [policyStatusOptions, setPolicyStatusOptions] = useState<SelectOption[]>([]);
    const [filteredPoliciesList, setFilteredPoliciesList] = useState<PolicyDtoRead[]>([]);

    const [customerPolicies, setCustomerPolicies] = useState<PolicyDtoRead[]>([]);
    let customerInfo = useSelector((state: RootState) => state?.customerSlice);
    const [showModal, setShowModal] = useState<boolean>(false);

    const onAddNewPolicy=async() =>{
        setShowModal(true);
    }
    const policyDto: PolicyDto = {   
                id:constant.DEFAULT_GUID,             
                policyNumber:  '',
                custId: customerInfo?.customerSummary?.id,
                polEffDate:  new Date() ,
                polExpDate:  CommonUtility.addToCurrentDate(1,'years') ,
                sourceId:  '' ,
                sourceTypeId:  '' ,
                typeOfBusId:  constant.policyActionSummaryConstant.Personal_Lines_businessTypeId,
                polTypeLobId:  '',//constant.policyActionSummaryConstant.HomeOwner_LobId ,
                policyEvents: [],
                issuedState:  '' ,
                priorPolicyId: constant.DEFAULT_GUID,
                policyTypeId: ''
            };  

    useEffect(() => {
        if (customerInfo && customerInfo.policies && customerInfo.policies.length > 0) {
            // Set customer policies
            setCustomerPolicies(customerInfo.policies);

            setSelectedPolicyStatus('');
            setSelectedPolicyType('');
            
            // Extract unique Policy Types
            const uniqueTypes = Array.from(new Set(customerInfo.policies.map(policy => policy.policyType)))
                .filter(type => type) // Remove null/undefined
                .map(type => ({
                    label: type,
                    value: type
                }));
            
            setPolicyTypeOptions(uniqueTypes);

            // Extract unique Policy Status
            const uniqueStatuses = Array.from(new Set(customerInfo.policies.map(policy => policy.polTermStatus)))
                .filter(status => status) // Remove null/undefined
                .map(status => ({
                    label: status,
                    value: status
                }));
            
            setPolicyStatusOptions(uniqueStatuses);

            // Initialize filtered list
            setFilteredPoliciesList(customerInfo.policies);
        }
    }, [customerInfo.policies]);

    var policiesPanels;
    if (path == -1) {
        policiesPanels = filteredPoliciesList.map(item => 
            <CustomerPolicySummary policySummary={item} isEditPolicyActivated={false} />
        );           
    } else {
        const effectivePolicyId = props.policyId || receivedState?.policyId;
        let data = customerInfo.policies.filter(item => item.id == effectivePolicyId)[0];
        if (!data) {
            // Policies not yet loaded from API (e.g. paste URL / refresh) — show loading state
            policiesPanels = [<div className="temp-component-place-holder">Fetching policy details.</div>];
        } else {
            // Build a minimal transaction object from URL params so polEventId reaches CustomerEditPolicyDetails
            const urlTransaction = props.polEventId
                ? { polEventId: props.polEventId } as PolicyTransactionsReadDto
                : (receivedState?.policyTransactionClicked ?? undefined);
            policiesPanels = <CustomerEditPolicyDetails policySummary={data} policyTransactionSelected={urlTransaction} onAddNewPolicy={onAddNewPolicy} />;
        }
    }
    if (policiesPanels.length == 0 && !customerInfo.isFetchingPolicyList) {
        policiesPanels = [<div className="temp-component-place-holder">No Policies found for customer.</div>]
    }
    if (customerInfo.isFetchingPolicyList) {
        policiesPanels = [<div className="temp-component-place-holder">Fetching policy details.</div>]
    }

    const handleFilterChange = (filterType: 'policyType' | 'policyStatus', selectedOption) => {
        const value = selectedOption ? selectedOption.toString() : '';
        
        // Update the appropriate state
        if (filterType === 'policyType') {
            setSelectedPolicyType(value);
        } else {
            setSelectedPolicyStatus(value);
        }
        
        // Apply filters
        let filtered = [...customerInfo.policies];
        
        const activeTypeFilter = filterType === 'policyType' ? value : selectedPolicyType;
        const activeStatusFilter = filterType === 'policyStatus' ? value : selectedPolicyStatus;
        
        if (activeTypeFilter) {
            filtered = filtered.filter(policy => policy.policyType === activeTypeFilter);
        }
        
        if (activeStatusFilter) {
            filtered = filtered.filter(policy => policy.polTermStatus === activeStatusFilter);
        }
        
        setFilteredPoliciesList(filtered);
    };

    // Handle Clear Click
    const handleClearClick = () => {
        setSelectedPolicyType('');
        setSelectedPolicyStatus('');
        setFilteredPoliciesList(customerInfo.policies);
    };
 

    return (
        <div className={`panel-container-policies p-3${path !== -1 ? ' no-top-padding' : ''}`} >
            {path === -1 && (
            <Row>
                <Column lg={2} md={2}>
                    <Select
                        id='policyTypeFilter'
                        label='Policy Type'
                        className='mb-3'
                        controlId='policyTypeFilter'
                        options={policyTypeOptions}
                        onChange={(value) => handleFilterChange('policyType', value)}
                        defaultSelected={policyTypeOptions?.filter(({ value }) => value === selectedPolicyType)}
                        // tabIndex={1}
                    />
                </Column>
                
                <Column lg={2} md={2}>
                    <Select
                        id='policyStatusFilter'
                        controlId='policyStatusFilter'
                        className='mb-3'
                        label='Policy Status'
                        options={policyStatusOptions}
                        defaultSelected={policyStatusOptions?.filter(({ value }) => value === selectedPolicyStatus)}
                        onChange={(value) => handleFilterChange('policyStatus', value)}
                        // tabIndex={2}
                    />
                </Column>
                
                <Column lg={1} md={1}>
                    <Button 
                        variant="primary" 
                        onClick={handleClearClick}
                        // tabIndex={4}
                        id="clearPoliciesFilter"
                        className="w-100"
                    >
                    Clear
                    </Button>
                </Column>
                    <Column lg={7} md={7} className="text-end">
                        <Button
                            variant="primary"
                            onClick={onAddNewPolicy}
                            // className="mt-4"
                        >
                            <i className="bi bi-plus-circle me-2"></i>
                            {labelconstant.PolicyActionLabels.ADD_NEW_POLICY}
                        </Button>
                    </Column>
            </Row>
            )}
            {policiesPanels}

            <Modal
            title={constant.policyActionSummaryConstant.NewModalTitle + customerInfo?.customerSummary?.displayName}
            verticallyCentered={true}
            show={showModal}
            toggle={() => setShowModal(!showModal)}
            body={
                
                    <div className='modal-div-class'>
                        <CustomerNewPolicy                          
                            selectedTransaction={constant.EventTransactionType.NBS}                         
                            defaultPolicyDto={policyDto}
                            selectedAction={constant.policyActionConstant.NEW}
                            onCloseModal={() => setShowModal(false)}
                        />
                    </div>
                              
            }
            className="custom-modal"                            
            />
        </div>
    );
}

export default CustomerPolicyList;